
import { Component, State, Vue } from 'nuxt-property-decorator';
import { Localization } from '@/types/initialData';
import { constructTYPO3Url } from '@/util/typo3Urls';
import { nrPageAction } from '@/util/newrelic-browser';

interface Language {
  hreflang: string;
  languageId: number;
}

@Component({})
export default class LanguageSwitch extends Vue {
  // @ts-ignore
  @State((state) => state.typo3?.page?.page?.id)
  pageId!: number;

  // @ts-ignore
  @State((state) => state.typo3?.initial?.site?.metadata?.localization)
  localization!: Localization;

  enabled: boolean = false;
  defaultLang: string = 'DA';
  defaultLangTitle: string = 'Dansk';
  currentLang: string = 'da';
  languages: object = {};
  toggleExclusive: number = 0;
  languageParam: string = '';
  changeToAlternate: string = '';
  mimWasWrong: boolean = true;
  alternateLangId: number = 0;

  mounted() {
    this.enabled = this.localization.languageSelector.enable;
    if (this.enabled) {
      this.setupLanguages();
      this.defaultLang = this.localization.languageSelector.defaultLangISO;
      this.defaultLangTitle =
        this.localization.languageSelector.defaultLangTitle;
      if (!this.mimWasWrong) {
        if (this.currentLang !== this.defaultLang) {
          this.alternateLangId = 0;
          this.changeToAlternate = this.setAlternateText(this.defaultLang);
        } else {
          this.alternateLangId = this.languages[0].languageId;
          this.changeToAlternate = this.setAlternateText(
            this.languages[0].hreflang
          );
        }
      }
    }
  }

  setAlternateText(locale: string): string {
    const label = this.$i18n.t('labels.usermenu.language.label', locale);
    return label.toString();
  }

  setupLanguages() {
    this.defaultLang =
      this.localization.languageSelector.defaultLangISO.toLowerCase();
    this.currentLang = this.$i18n.localeProperties.code.toLowerCase();
    this.languages = this.localization.languageSelector.availableLanguages;

    // Filter out as active language is both 0 and the actual L-var
    this.languages = Object.keys(this.languages)
      .map((key) => this.languages[key])
      .filter((element) => element.languageId > 0);
    this.languageParam = new URLSearchParams(location.search).get('L') ?? '';
    this.setActiveLang(this.languageParam);
  }

  handleClick(id: number, isoCode: string = '') {
    let url = '';
    const queryHasId = Object.prototype.hasOwnProperty.call(
      this.$route.query,
      'id'
    );

    // if no pageId, we assume you are changing language from a static page
    if (queryHasId) {
      url = constructTYPO3Url(this.pageId.toString(), id.toString());
    } else {
      url = constructTYPO3Url(this.$route.path, id.toString(), true);
    }

    nrPageAction('ChangeLanguage', {
      changeToId: id,
      changeToISO: isoCode.toLowerCase(),
      type: 'Button',
      component: 'LanguageSwitch'
    });

    return window.location.replace(url);
  }

  setActiveLang(languageParam: string) {
    Object.values(this.languages).forEach((language: Language, index) => {
      if (language.languageId === parseInt(languageParam)) {
        this.toggleExclusive = index + 1;
      }
    });
  }
}
